import React from 'react';

/**
 * Encapsula o padrão isLoading ? spinner : tabela, presente em todas as páginas de listagem.
 * Padrão: tabela responsiva com scroll vertical limitado à altura da viewport.
 *
 * Props:
 *  - isLoading   {boolean}  Exibe o spinner enquanto verdadeiro.
 *  - className   {string}   Classe(s) do wrapper (default: table-responsive table-scroll table-dynamic-value).
 *  - style       {object}   Sobrescreve/complementa o estilo padrão.
 *  - children               Conteúdo da tabela (<table>, <tfoot>, etc.).
 */
const DEFAULT_STYLE = { overflow: 'auto', position: 'relative', backgroundColor: '#f8f9fa' };

const TableContainer = ({ isLoading, children, className = 'table-responsive table-scroll table-dynamic-value', style }) => {
  if (isLoading) {
    return (
      <div className="text-center">
        <span className="spinner-border spinner-border-sm"></span>
      </div>
    );
  }

  return (
    <div className={className || undefined} style={style ? { ...DEFAULT_STYLE, ...style } : DEFAULT_STYLE}>
      {children}
    </div>
  );
};

export default TableContainer;
